(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("encrypt-storage", [], factory);
	else if(typeof exports === 'object')
		exports["encrypt-storage"] = factory();
	else
		root["encrypt-storage"] = factory();
})(self, () => {
return 